import { Component, Input } from '@angular/core';
import { AbstractControlDirective, AbstractControl } from '@angular/forms';

@Component({
  selector: 'show-errors',
  template: `
    <ng-template #errors>
      <p *ngFor="let error of listOfErrors()">
        {{error}}
      </p>
    </ng-template>
    <div *ngIf="shouldShowErrors()">
      <i 
      class="text-danger error icofont icofont-close-circled" 
      placement="top"
      [ngbTooltip]="errors"></i>
    </div>
  `,
  styles: []
})
export class ShowErrorsComponent  {

  constructor() { }
  private static readonly errorMessages = {
    'required': () => 'El campo es requerido',
    'minlength': (params) => 'La cantidad mínima de caracteres es ' + params.requiredLength,
    'maxlength': (params) => 'La cantidad máxima permitida de caracteres es ' + params.requiredLength,
    'pattern': (params) => 'El patrón no es correcto',
    'years': (params) => params.message,
    'countryCity': (params) => params.message,
    'uniqueName': (params) => params.message,
    'telephoneNumbers': (params) => params.message,
    'telephoneNumber': (params) => params.message,
    'email':(params) => 'No es un correo valido'
  };
  @Input() control: AbstractControlDirective | AbstractControl;

  shouldShowErrors(): boolean {
    return this.control &&
      this.control.errors &&
      (this.control.dirty || this.control.touched);
  }

  listOfErrors(): string[] {
    return Object.keys(this.control.errors)
      .map(field => this.getMessage(field, this.control.errors[field]));
  }

  private getMessage(type: string, params: any) {
    return ShowErrorsComponent.errorMessages[type](params);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/element/show-errors.component.ts